import { decode, encode } from "../utils/helper";

export const setStorageItemLocal = (key: string, value: string) => {
  localStorage.setItem(key, encode(JSON.stringify(value)));
};

export const getStorageItemLocal = (key: string): string | null => {
  const storedData = localStorage.getItem(key);
  if (!storedData) return null; // Handle null before passing to decode

  const decoded = decode(storedData);
  return decoded;
};
